import { render } from "./FooterTop.vue?vue&type=template&id=6aaa81c3&scoped=true"
import script from "./FooterTop.vue?vue&type=script&lang=js"
export * from "./FooterTop.vue?vue&type=script&lang=js"

import "./FooterTop.vue?vue&type=style&index=0&id=6aaa81c3&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aaa81c3"]])

export default __exports__